// extracted by mini-css-extract-plugin
export default {"memberImage":"styles_memberImage__Wy87T","subtitle":"styles_subtitle__5BWQJ","description":"styles_description__TfnSO"};